export class CurrencyHelper {
  static getCurrencyIcon (currency) {
    for (let key in this.currency) {
      if (currency === key) {
        return this.currency[key]
      }
    }
    return currency.toUpperCase()
  }

  static currency = {
    USD: '$',
    UAH: '₴',
    EUR: '€',
    BTC: '₿',
    ETH: 'ETH'
  }
}



// WEBPACK FOOTER //
// ./src/js/helpers/currency.helper.js